import { Component, ViewChild } from '@angular/core';
import { Config, Nav, Platform, MenuController, AlertController, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG } from "./app.config";
import { Utils } from "./utils";
import { Deeplinks } from '@ionic-native/deeplinks';
import { ActivatePage } from '../pages/activate/activate';
import { PerfilPage } from '../pages/perfil/perfil';
import { AppVersion } from '@ionic-native/app-version';
import { GlobalData } from './globaldata';
import { Device } from '@ionic-native/device';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:string = 'WelcomePage';

  @ViewChild(Nav) nav: Nav;

  utils: Utils = new Utils();

  GlobalData: any = GlobalData;
  version: string;

  usuario: any = {
    email: "",
    razon: "",
    nombre: "",
    apellidos: "",
    doi: "",
    movil: "",
    fechaNacimiento: "",
    locale: "es",
    playSound: true,
    vibrate: true,
    newPassword: "",
    confirmPassword: ""

  };

  constructor(private translate: TranslateService, 
    private platform: Platform, 
    private config: Config, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen, 
    private menu: MenuController, 
    public alertCtrl: AlertController,
    public app: App,
    private deeplinks: Deeplinks,
    private appVersion: AppVersion,
    private device: Device
    ) {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      //
      //splashScreen.hide();
      // APP_CONFIG.log("hide splash");
      // splashScreen.show();

      // console.log('Device UUID is: ' + this.device.uuid);
      // console.log(device.cordova);
      // console.log(device.isVirtual);
      // console.log(device.manufacturer);
      // console.log(device.model);
      // console.log(device.platform);
      // console.log(device.serial);
      // console.log(device.uuid);
      // console.log(device.version);
      
      // console.log("idioma");  
      // console.log(window.localStorage["locale"]);

      window.localStorage.setItem("uuid", this.device.uuid);
      window.localStorage.setItem("manufacturer", this.device.manufacturer);
      window.localStorage.setItem("model", this.device.model);
      window.localStorage.setItem("platform", this.device.platform);
      window.localStorage.setItem("serial", this.device.version);

      // console.log('cordova ' + platform.is('cordova'));
      // console.log('mobileweb ' + platform.is('mobileweb'));
      // console.log('ios ' + platform.is('ios'));
      // console.log('mobile ' + platform.is('mobile'));
      // console.log('android ' + platform.is('android'));
      // console.log('wp ' + platform.is('wp'));
      // console.log('core ' + platform.is('core'));
      if(!this.platform.is('mobileweb') && (this.platform.is("ios") || this.platform.is("mobile") || this.platform.is("android") || this.platform.is("wp"))) {
        appVersion.getVersionNumber().then(value => {
          this.version = value.toString();
          window.localStorage.setItem("version", this.version);    
        });

        this.deeplinks.routeWithNavController(this.nav, {
          '/activate/:codigo': ActivatePage//,         '/products/:productId': HelpPage
        }).subscribe(match => {
            // match.$route - the route we matched, which is the matched entry from the arguments to route()
            // match.$args - the args passed in the link
            // match.$link - the full link data
            console.log('Successfully matched route', match);
          }, nomatch => {
            // nomatch.$link - the full link data
            console.error('Got a deeplink that didn\'t match', nomatch);
          });      
      }
      else {
        this.version = "web";
        window.localStorage.setItem("version", this.version);    
      }
  
      
    //   platform.registerBackButtonAction(() => {
    //     // Catches the active view
    //     let nav = this.app.getActiveNavs()[0];
    //     let activeView = nav.getActive();                
    //     // Checks if can go back before show up the alert
    //     if(activeView) {
    //       //if(activeView.name === 'HomePage') {
    //         if (nav.canGoBack()){
    //             nav.pop();
    //         } else {
    //             const alert = this.alertCtrl.create({
    //                 title: 'Fechar o App',
    //                 message: 'Você tem certeza?',
    //                 buttons: [{
    //                     text: 'Cancelar',
    //                     role: 'cancel',
    //                     handler: () => {
    //                       this.nav.setRoot('HomePage');
    //                       console.log('** Saída do App Cancelada! **');
    //                     }
    //                 },{
    //                     text: 'Fechar o App',
    //                     handler: () => {
    //                       this.logout();
    //                       platform.exitApp();
    //                     }
    //                 }]
    //             });
    //             alert.present();
    //         }
    //       //}
    //     }
    // });

 

     });

     
    this.initTranslate();
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.addLangs(['en', 'fr', 'es']);
    this.translate.setDefaultLang('es');
    const browserLang = this.translate.getBrowserLang();
    // console.log("browserLang");  
    // console.log("-" + browserLang + "-");
    // console.log("idioma");  
    // console.log(window.localStorage["locale"]);

    if(window.localStorage["locale"] != undefined) {      
      this.translate.use(window.localStorage["locale"]); // Set your language here
    }
    else {
      if (browserLang) {
        window.localStorage["locale"] = browserLang;
        if (browserLang === 'zh') {
          const browserCultureLang = this.translate.getBrowserCultureLang();

          if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
            this.translate.use('zh-cmn-Hans');
            window.localStorage["locale"] = 'es';
          } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
            this.translate.use('zh-cmn-Hant');
            window.localStorage["locale"] = 'es';
          }
        } else {
          this.translate.use(this.translate.getBrowserLang());
          window.localStorage["locale"] = this.translate.getBrowserLang();
        }
      } else {
        this.translate.use('es'); // Set your language here
        window.localStorage["locale"] = 'es';
      }
    }

    this.translate.get(['BACK_BUTTON_TEXT']).subscribe(values => {
      this.config.set('ios', 'backButtonText', values.BACK_BUTTON_TEXT);
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  gotoCalendar() {
    this.menu.close();
    this.nav.push("CalendarPage");
  }

  addInvitation() {
    this.menu.close();
    this.nav.push("ActivatePage");
  }
  showDemo() {
    this.menu.close();
    this.nav.push("SliderDemoPage");
  }

  logout() {
    this.menu.close();
    window.localStorage.removeItem("email");
    window.localStorage.removeItem("password");
    window.localStorage.removeItem("remember");
    window.localStorage.removeItem("uid");
    window.localStorage.removeItem("sid");
    window.localStorage.removeItem("escenas");
    window.localStorage.removeItem("version");
    window.localStorage.removeItem("endsession");
    window.localStorage.removeItem("rol");
    window.localStorage.removeItem("diapositiva");
    this.nav.setRoot("WelcomePage");
  }  

  viewProfile() {
    this.menu.close();
    this.nav.push("PerfilPage");
  }

  public changeLocale(locale: string) {
    window.localStorage["locale"] = locale;
    //console.log("idioma locale");  
    //console.log(window.localStorage["locale"]);
  this.translate.use(window.localStorage["locale"]); // Set your language here
    

  }

  showLastSlide() {
    if(window.localStorage.getItem("diapositiva") && "undefined" != window.localStorage.getItem("diapositiva")) {
      return true;
    }
    else {
      return false;
    }
  }
  showCustomSlide() {

    this.menu.close();
    
    if(window.localStorage.getItem("diapositiva") && "undefined" != window.localStorage.getItem("diapositiva"))
      this.nav.setRoot("DiapositivasPage", { diapositiva: JSON.parse(window.localStorage["diapositiva"])["diapositivaId"], titulo: JSON.parse(window.localStorage["diapositiva"])["titulo"]});
  }
  getCustomSlideTitle() {    
    if(window.localStorage.getItem("diapositiva") && "undefined" != window.localStorage.getItem("diapositiva")) {
      console.log(window.localStorage.getItem("diapositiva"));
      
      return JSON.parse(window.localStorage.getItem("diapositiva"))["titulo"];
    }
    else
      return "LAST_SLIDE";
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts